import DateFormatResolver from 'resolvers/date-format.resolver';

export default (data = [], granularity) => {
	const totalData = [];
	const iosData = [];
	const androidData = [];
	const labels = [];
	const dateFormat = granularity === 'hour' ? 'hA' : 'DD MMM `YY';
	for (let i = 0; i < data.length; i += 1) {
		totalData.push(data[i].totalRegistrationsCount);
		iosData.push(data[i].iosRegistrationsCount);
		androidData.push(data[i].androidRegistrationsCount);
		labels.push(DateFormatResolver.resolve(data[i].timeSlot, dateFormat));
	}
	const pointRadius = data.length > 50 ? 0 : 3;
	const borderWidth = data.length > 50 ? 1 : 3;

	return {
		data: {
			labels,
			datasets: [
				{
					label: 'Total',
					data: totalData,
					fill: false,
					borderColor: '#3fbdd6',
					pointBackgroundColor: '#3fbdd6',
					pointRadius,
					borderWidth,
				},
				{
					label: 'IOS',
					data: iosData,
					fill: false,
					borderColor: '#df1962',
					pointBackgroundColor: '#df1962',
					pointRadius,
					borderWidth,
				},
				{
					label: 'Android',
					data: androidData,
					fill: false,
					borderColor: '#ffa21a',
					pointBackgroundColor: '#ffa21a',
					pointRadius,
					borderWidth,
				},
			],
		},
		options: {
			plugins: {
				datalabels: {
					display: false,
				},
			},
			responsive: true,
			maintainAspectRatio: false,
			legend: {
				display: false,
			},
			scales: {
				xAxes: [
					{
						scaleShowGridLines: true,
						ticks: {
							fontColor: 'rgba(0, 0, 0, 0.2)',
							fontSize: 14,
						},
						gridLines: {
							display: false,
						},
					},
				],
				yAxes: [
					{
						ticks: {
							stepSize: 1,
							min: 0,
							beginAtZero: true,
							fontColor: 'rgba(0, 0, 0, 0.2)',
							fontSize: 14,
						},
						gridLines: {
							display: true,
							drawBorder: false,
							borderDash: [2, 2],
							color: 'rgba(0, 0, 0, 0.2)',
						},
					},
				],
			},
		},
		customLegend: [
			{
				color: '#3fbdd6',
				text: 'Total',
			},
			{
				color: '#df1962',
				text: 'iOS',
			},
			{
				color: '#ffa21a',
				text: 'Android',
			},
		],
		type: 'line',
		hasData: labels.length > 0,
	};
};
